import type { VisibilityLevel } from '@seek/ca-graphql-schema/types';

import type { useRoutes } from './routes';

export const CategoryName = {
  UPDATES: 'updates',
  OPPORTUNITIES: 'opportunities',
};

interface CustomAction {
  label: string;
  link: keyof ReturnType<typeof useRoutes>;
}

interface CustomProduct {
  label: string;
  descriptionJsx: React.ReactElement;
}

export interface CustomCategory {
  product: CustomProduct;
  action: CustomAction;
  testId: string;
}

export type CustomCategoryProfileDescription =
  | 'category-profile-not-been-specified-description'
  | 'category-profile-standard-description'
  | 'category-profile-limited-description'
  | 'category-profile-hidden-description';

export const generateProfileDescriptionVocabKey = (
  profileLevel: VisibilityLevel | undefined | null,
): CustomCategoryProfileDescription =>
  `category-profile-${
    profileLevel ? profileLevel.toLowerCase().toString() : 'not-been-specified'
  }-description` as CustomCategoryProfileDescription;
